import enLocale from 'element-ui/lib/locale/lang/en'
import store from "../../../store";
module.exports = {
    ...enLocale,
    selectLanguage: 'Language',
    chinese: 'Chinese',
    english: 'English',
    logout: 'Logout',
    netError: "Network error. Try again later.",
    cancel:"Cancel",
    confirm:"Apply",
    delete:"Delete",
    save:"Save",
    recovery: "Restore",
    rename:"Rename",
    userSpace: "Personal space",
    entSpace: "Enterprise space",
    allUser: "All users",
    frozen: "Frozen",
    upload: "Upload",
    import: "Import",
    tips: "Reminder",
    prompt: "Reminder",
    success: "Success",
    return: "Back",
    edit:"Edit",
    close: "Close",
    noSearch: "No search results",
    loadmore: "Upload more",
    retry: "Try again",
    allDelete: "Delete all",
    nextStep:"Next",
    nodata:'No related query results',
    back: "Previous",
    gotIt:"Got it",
    ad: 'AD',
    corpWX: 'WeChat Work',
    dingding: 'DingTalk',
    weaverOA:'weaverOA',
    weaver:'weaver',
    LDAP: 'LDAP',
    ADFS: 'ADFS',
    kingdee: 'Kingdee',
    moduleType: 'Module Type',
    serviceType: 'Service Type',
    search: 'Search',
    discription:'Discription',
    creater: 'Creater',
    createTime: 'Create Time',
    version: 'Version',
    status: 'Status',
    operation: 'Operation',
    read: 'Read',
    start: 'Start',
    stop: 'Stop',
    data: 'Json Data',
    create: 'Create',
    runing: 'Runing',
    toDelete: 'Confirm Deletion?',
    more: 'More',
    batchStart: 'Batch Start',
    batchStop: 'Batch Stop',
    batchDelete: 'Batch Delete',
    message:{
        addSuccess:'Added successfully',
        deleteSuccess:'Deleted successfully',
        dismissSuccess:'Dissolved successfully',
        setSuccess:'Setting is successful',
        setFailed:'Setting is Faild',
    },
    valid: { //校验
        noSpace: "Empty space size is not allowed",
        intSpace: "Enter a positive integer for space size",
        moreSpace: "The total enterprise space size shall not be exceeded",
        moreData: "Data center capacity shall not be exceeded",
        noPwd: "Password cannot be blank",
        limitWord: "The length is between 6 and 32 characters",
        manyWord: "6 to 32 characters. It must include two different kinds of characters from the following: letters, numbers, and symbols",
        phone: "Enter correct mobile phone number",
        noMail: "Please enter your login email",
        errorMail: "Enter email address in the correct format",
        noName: "Enter your name",
    },
    log: {
        userSpace: "Personal space",
        entSpace: "Enterprise space",
        time: "Time",
        actionName: "Action",
        netError: "Network error. Try again later.",
        title: "Log query",
        datearea: "Time",
        dateareaTip: "To ensure query efficiency, you may query logs as far as 31 days at a time.",
        dateTo: "To",
        dateStart: "Start date",
        dateEnd: "End date",
        logExport: "Export log",
        category: "Action",
        allCategory: "All",
        action: "Action",
        allAction: "All actions",
        space: "Space",
        allSpace: "All space",
        pathValue: "Path keywords",
        pathValuePH: "Enter path keywords",
        operator: "Operator",
        operatorPH: "Operater",
        optionOther: "Additional filtering conditions",
        search: "Query",
        reset: "Reset",
        object: "Object",
        detail: "Details",
        ip: "IP address",
        device: "Device",
        logNull: "No related logs found",
        logNull2: "Try again after modifying the query conditions",
        userSearchNot: "The operator was not found",
        userStrSize: "An operator can input a maximum of 50 characters",
        fileName: "File",
        folderName: "Folder",
        freeze: "Freeze",
        team: "Teams",
        select: "Selected",
        item: "Items",
        nullData: "None",
    },
    logTimingExport:{
        delete: "Delete",
        title: "Scheduled exporting of log",
        headInfo: "Log files of the previous monthes will be exported regularly at the beginning of each month. Log files will be maintained for {year} years. Please download the files in time.",
        noLog: "No logs have been generated yet",
        openTimingExport: "Timed log export has been enabled",
        closeTimingExport: "Timed log export has been disabled",
        comfirmDelete: "Are you sure you want to delete the selected log files?",
        deleteSuccess: "Logs deleted successfully",
        deleteLog: "Delete logs",
        fileName: "Filename",
        creatTime: "Export time",
        operation: "Operation",
        download: "Download",
        batchDownload: "Download in bulk",
        logExportLanguage: "Log file language",
        logExportLanguageTips: "The language has been switched successfully and will take effect the next time an export is performed.",
    },
    fileTemp:{
        all:"All",
        edit:"Edit",
        operate:"Operation",
        topword:"Top",
        fileTemptitle: "File template",
        fileTempType: "Template types",
        newFileTempType: "New template type",
        searchPlaceholder: "Search by template keywords",
        typeManage: "Type management",
        addTemp: "New file template",
        editTemp: " Edit templates",
        defaultType: "Default type",
        tempTypeName: "Name",
        DC: "Data Center",
        tempTeam: "Teams applicable to",
        state: "Status",
        pbliushT: "Released",
        pbliushF: "Not released",
        publish: "Release",
        repeal: "Cancel",
        deleteTemp: "Delete templates",
        more: "More",
        top: "Stick up",
        cancelTop: "Cancel stick up",
        deleteTempTips: "Are you sure to delete the current template?",
        allTeam: "All teams",
        typeName: "Type name",
        typeNamePlaceholder: "Enter type name",
        tempTypeMaxNum: "The maximum number of template types has been reached. Unable to continue the creation",
        tempMaxNum: "The maximum number of templates has been reached. Unable to continue the creation",
        notNull: "It must not be empty or blank",
        strReg: "It must not contain characters including /\\:*?\"<>|",
        max10: "A maximum of 10 characters may be input",
        tempPlaceHolder: "Enter template name",
        tempTypePlaceHolder: "Select a template type",
        teamPlaceHolder: "Select a team",
        selectFile: "Choose file",
        amend: "Modify",
        selectFromPan: "Select file",
        teamNotNull: "No teams have been added",
        fileNotNull: "Please select a file",
        sizeReg: "The file size cannot be more than 50 MB",
        viriusFile: "The file contains a virus and is unavailable",
        tempTypeManage: "Template type management",
        addType: "Add types",
        deleteTitle: "Delete template types",
        deleteTypeTips1: "There are template files in the template type to be deleted,",
        deleteTypeTips2: "Select a way for handling the template files",
        deleteTypeTips3: "If you only delete the template type, the template file type will be set as default",
        allDelete: "Delete all",
        onlyTypeDelete: "Only delete types",
        publishSuccess: "Released successfully",
        topSuccess: "Stick up set successfully",
        cancelTopSuccess: "Canceled stick up successfully",
        repealSuccess: "Canceled successfully",
        saveSuccess: "Saved successfully",
        searchNull: "Not found",
        listNull: "The file template list is empty",
    },
    offline: {
        LinkModeTitle: "Link rules:",
        approvalRule:'When the controlled object sends a link from the enterprise space, except the following approval rules, all follow {rule} for approval to prevent file leakage',
        selectedSummary: "Total {personNum} members,{teamNum} teams",
        selectedSummaryEnt: "Total {personNum} members,{teamNum} teams,{orgNum} organizations",
        controlUser: "Add control member",
        directory: "Total {0} directories",
        belongTeam: " {0} teams",
        copymove: "Files in the directory",
        linkApprover: 'Link approver',
        linkApproverInput: 'Enter username or email, you can set up to 5 approvers',
        linkApproverTips: 'If no approver is specified, {str} is followed',
        linkApproverTipsInsert: ' the default approver logic',
        approverDialogTitle: 'Default approver logic',
        readyApproverTips: 'No approver is specified, following the default approver logic',
        approverLogic1:'1.Common members create links, and the default approver is the nearest {admin} for the file.',
        approverLogic2:'2.If the person creating the link is the {admin} of the link file, the default approver is the nearest superior {admin}.',
        approverLogic3:'3.There is no {admin} for creating links. The default approver is the network disk administrator.',
        approverLogic4:'Nearest definition: Recursively go up to the {admin} at the next level up to the network disk administrator.',
        notes:'Note:',
        approverDocAdmin: 'document administrator',
        approverTeamAdmin: 'team administrator',
        forbiddenCopymove:'No Move/Copy',
        forbiddenCopymoveTip:'After selecting No Move/Copy, the control files downloaded through the client can only be transferred back to the original directory through the client.',
        forbiddenCopymove1: 'Are you sure you want to cancel the "No Move / Copy" option?',
        forbiddenCopymove2: 'After cancellation, authorized users may move / copy in this directory to other directories without the specified approval',
        copymoveTip: "The files in the control directory and all parent directories are restricted (the file paths in the control directory are restricted at all levels)",
        maxWhite: "Whitelist members cannot exceed {0}",
        maxDir: "Whitelist directories cannot exceed {0}",
        defaultApprovers: 'Default approver',
        etc:'{name} and {num} others',
        cancel: "Cancel",
        confirm: "Apply",
        confirmTitle: "Reminder",
        masterSwitchTitle: "Offline file control",
        encryptModeTitle: "Key mode:",
        encryptEntMode: "Encryption and decryption by enterprises",
        encryptEntModeTip: "The downloaded encrypted file can be decrypted by all enterprise members.",
        encryptAccountMode: "Encryption and decryption by accounts",
        encryptAccountModeTip: "The downloaded encrypted file can only be decrypted by the downloading user.",
        approvalLinkMode: "Approval needed before creating links",
        banLinkMode: "Links are prohibited",
        switchEncryptTip: "Previously downloaded files will not be decrypted after switching to password key mode. Continue?",
        submit: "Submit",
        submitSuccess: "Submitted successfully",
        hotLine: "Call customer service at 400-898-7968 to activate the service",
        offlineTip: "Network error. Try submitting it again.",
    },
    memberControl: {
        frozon: "Frozen",
        noTeamSearch: "No corresponding teams or members",
        noUserSearch: "No corresponding members",
        existTip: "The same person or team cannot be repeated",
        existToast: "Cannot select the same person",
        maxLenTip: "Failed to add. Too many teams or members.",
        controlList: "Members under control:",
        whiteList: "Whitelist",
        partMember: "Some of the teams/members",
        partMemberEnt: "Some of the teams/departments/members",
        allMember: "All members",
        noControlList: "Members/teams under control have not been added",
        noControlListEnt: "Members/teams/departments under control have not been added",
        noWhiteList: "Members on the control whitelist have not been added",
        selectedSummary: "{teamNum} teams and {personNum} members have been under control",
        selectedSummaryEnt: "{teamNum} teams, {orgNum} departments, and {personNum} members have been under control",
        selectedMemberSummary: "{personNum} members selected",
        searchPlaceholder: "Search for team name, username, or email address",
        searchMemberPlaceholder: "Search for username or email address",
        dialogTitle: "Select teams/members",
        dialogVerSelectedMemberSummary: "({personNum}) have been added to the whitelist",
    },
    controlDictionary: {
        noResult: "No search results",
        title: "Search for or select teams/members",
        searchPlaceholder: "Search for username, email address, or team name",
        searchOrgTeam: "Search for username, email address, or department name",
        selectedSummary: "{teamNum} teams and {personNum} members selected",
        selectedSummaryEnt: "{teamNum} teams, {orgNum} departments, and {personNum} members selected",
        noMemberAdded: "Select teams/members to be added",
        noMemberEnt: "Select teams/departments/members to be added",
        selectAll: "Select all",
        searchSelectedSummary: "{n} items have been selected",
        addButton: "Add",
        category: "Categories:",
        teamUser: "Teams and members",
        orgUser: "Departments and members",
    },
    edas: {
        ad: 'AD',
        baseDN: 'Base DN',
        corpId: 'corpid',
        appId: 'appId',
        corpSecret: 'corpSecret',
        ProviderSecret: 'ProviderSecret',
        secret: 'secret',
        appKey: 'appKey',
        appSecret: 'appSecret',
        authentication: "Authentication config",
        //URL:'URL',
        LDAP: 'LDAP',
        ADFS: 'ADFS',
        callBackUrl: 'CallbackURL',
        //agentId: 'agentId',
        status: 'Status',
        operation: 'Operation',
        cancel: 'Cancel',
        confirm: 'Apply',
        next: 'Next',
        last: 'Previous',
        delete: 'Delete',
        tips: 'Reminder',
        // weaver:'weaver',
        // weaverOA:'weaverOA',
        none: 'None',
        submit: 'Submit',
        // departmentID: 'Department ID',
        // departmentName: 'Department name',
        // parentDepartment:'Parent department',
        // agentTips:'The current service type does not need to select a proxy name',
        // syncMode: 'Sync mode',
        // syncOrganization: 'Sync to department',
        // syncTeam: 'Sync to team',
        // syncUserOnly: 'Synchronize users only',
        // syncOrganizationToolTip: 'Synchronize the teams and person of the enterprise system to the box department',
        // syncTeamToolTip: 'Synchronize the teams and person of the enterprise system to the box teams',
        // syncUserOnlyToolTip: 'Synchronize only the person of the enterprise system to the root of the box department',
        hours: 'hour(s)',
        mins: 'Minute',
        more: 'More',
        back: 'Back',
        detail: 'Details',
        object: 'Object',
        action: 'Action',
        //remarks: 'remarks',
        success: 'Success',
        team: 'Team',
        //move: 'Moved',
        frozen: 'Frezzed',
        netError: "Network error. Try again later.",
        setFilter: 'Set sync filter',
        import: 'Import',
        modify: 'Modify',
        upload: 'Upload',
        edit: 'Edit',
        condition: 'items',
        loadMore: 'Load more',
        items: 'items',
        agentId: 'agentId',
        weaver:'weaver',
	    weaverOA:'weaverOA',
        customize: 'customize',
        URL:'URL',
        departmentID: 'Department ID',
        departmentName: 'Department name',
        parentDepartment:'Parent department',
        agentTips:'The current service type does not need to select a proxy name',
        syncMode: 'Sync mode',
        syncOrganization: 'Sync to organization',
        syncTeam: 'Sync to team',
        syncUserOnly: 'Synchronize users only',
        syncOrganizationToolTip: 'Synchronize the organization and personnel of the docking system to the network disk organization',
        syncTeamToolTip: 'Synchronize the personnel of the docking system to the organization and the organizational structure of the docking system to the team',
        syncTeamToolTipNotEnterPrise: 'Synchronize the organizational structure of the docking system to the team',
        syncUserOnlyToolTip: 'Synchronize only the personnel connected to the system to the root node of the organization, not the organization',
        syncUserOnlyToolTipNotEnterPrise: 'Synchronize only the personnel connected to the system to the root node of the team, not the organization',
        remarks: 'remarks',
        move: 'Moved',
        mostCustomNumber: '	Up to {0} fields',
        createAgentFirst: 'Please configure proxy service first',
        hasNoAgentNow: 'No agency service',
        notNeedAgent: 'No proxy name required for current service type',
        connectFieldName: 'Name',
        connectFieldContent: 'Content',
        enterConnectFieldName: 'Please enter a connection configuration item name',
        enterConnectFieldContent: 'Please enter the connection configuration item',
        organization:'department',
        unSyncOrganization:'Unsynchronized departments',
        urlTip:'Please enter a URL with http:// or https://',
        title: "Enterprise account authentication",
        subHeader: "Connecting the box to the enterprise domain through proxy service,you can import and synchronize enterprise users and department structures.",
        subHeader2: "ps:Work WeChat authentication service does not require proxy services.",
        importServerConfig: "Department import service configuration",
        sync: "Department import service configuration",
        authServerConfig: "Login authentication service configuration",
        auth: "Login authentication service configuration",
        agentName: "Proxy name",
        serviceName: "Service name",
        serial: "Serial number",
        ctime: "Create time",
        addAgentServer: "Add proxy service",
        addServerConfig: "Add service configuration",
        editServerConfig: "Edit service configuration",
        autoSyncTime: "Sync time",
        lastSyncTime: "Last sync time",
        newAgentSrver: "New proxy service",
        unbound: "Remove binding",
        unbind: "Unbound",
        normal: "Normal",
        disconnect: "Disconnected",
        hasAddAgentServer: "Proxy service has been added",
        unboundTips: "The proxy service will be unavailable after unbinding. Are you sure you want to continue unbinding?",
        confirmUnbound: "Continue unbinding",
        deleteTips: "The service will be unbound and relevant parameters will be cleared if it is deleted. Are you sure you want to continue?",
        serviceType: "Service type",
        corpWX: "WeChat Work",
        dingding: "DingTalk",
        connectConfig: "Connection configuration",
        serviceAddress: "Server address",
        serviceManageAccount: "Account name",
        password: "Password",
        port: "Port",
        fieldMapping: "Field mapping",
        userID: "User ID",
        userNameField: "Username",
        emailField: "User email",
        mobileField: "User mobile",
        login: "User login",
        teamID: "Team ID",
        teamName: "Team",
        allowMailImportToBeEmpty: "The email addresses can be empty",
        mailImportToolTip: "If you uncheck this option, users without email address will not be imported",
        customField: "Custom field",
        lenovoboxField: "Network disk field",
        importField: "Import fields",
        addField: "Add fields",
        syncConfig: "Synchronization configuration",
        defaultImportMode: "Import mode",
        allImport: "Import all",
        allNoImport: "Import none",
        syncTime: "Sync time",
        accordingDay: "By day",
        accordingHour: "By hour",
        hour: "hour",
        min: "minute",
        adfsCertificate: "ADFS certificate (JKS format)",
        certificatePassword: "Certificate password",
        adfsAddress: "ADFS address",
        everyday: "Every day",
        every: "Every",
        syncOperation: "Synchronize now",
        log: "Log",
        setServiceConfig: "Set up service configuration",
        setFiltrationConditions: "Set up filtering conditions",
        deleteSuccess: "Deleted successfully",
        syncCompleteTime: "Synchronization completion time",
        syncSuccess: "Synchronized successfully",
        syncFail: "Sync unsuccessful ",
        unSync: "Unsynchronized",
        unSyncToolTip: "Filter data that is not synchronized through the blacklist",
        export: "Export",
        syncDetail: "Sync details",
        detailSyncTime: "Sync time",
        allSyncResult: "All sync results",
        failReasons: "Reasons for the failure",
        fail: "Failed",
        user: "User",
        created: "Create",
        update: "Update",
        unfrozen: "Unfreeze",
        filter: "Filtered",
        unSyncUser: "Users not synchronized",
        unSyncTeam: "Teams not synchronized",
        importServiceConfigCuccess: "The service configuration import was added successfully!",
        filterInquiry: "Do you want to set up the import filtering conditions now?",
        noSettings: "Do not set up for now",
        goSettings: "Go set up",
        addFilter: "Add conditions",
        addFilterCondition: "Add filtering conditions",
        modifyFilterCondition: "Edit filtering conditions",
        batchImport: "Import in bulk",
        userEmail: "User email",
        userPhone: "User mobile phone",
        userName: "Username",
        teamUser: "Team name",
        filteringContent: "Filtered content",
        allConditionalType: "All condition types",
        allFilterMode: "All filtering methods",
        noImport: "Do not import",
        conditionalType: "Condition type",
        filterMode: "Filtering method",
        importModeDesc: "The import method can be changed in service configuration",
        addedNumber: "Added",
        addedText: "conditions",
        first: "Step 1",
        downloadTemp: "Download templates",
        downloadTempDesc: "xls or xlsx file",
        second: "Step 2",
        editedUpload: "Upload after editing the content",
        uploadCertificate: "Upload certificate",
        deleteItem: "Delete selected items",
        selectedText: "Are you sure you want to delete the selected items?",
        importLogTitle: "Import the list of configuration logs",
        mostNumber: "10 fields at most",
        enterLenovoboxField: "Enter the zBox field",
        enterImportField: "Enter the import field",
        agentRelease: "Proxy binding has been removed",
        noServiceConfig: "No service configuration is added",
        noAgentService: "No proxy service is added",
        syncConfigDesc: "You may add filtering conditions to filter a part of the users",
        noDetailResulr: "No corresponding search results",
        filterTitleTip: "All data will be imported by default. You may set it to not import any and add conditions to import a part of the data",
        importAcount: "The total amount of imported items",
        copy: "Copy",
        copySuccess: "Copied",
        copyFail: "Copy unsuccessful",
        serviceNamePlaceholder: "Enter service configuration name using 50 characters at most",
        serviceAddressPlaceholder: "e.g.: 120.22.100.11",
        manageAccountPlaceholder: "Enter admin account of server to be connected",
        enterPasswordPlaceholder: "Please enter your password",
        verificationRequired: 'Please enter the verification code',
        verificationTip: 'Can\'t see clearly, please click',
        enterSearchValue: "Enter content to be searched",
        selectFilterType: "Select the type of filtering conditions",
        enterEmail: "Enter user's email address",
        enterUserPhone: "Enter user's mobile phone number",
        enterUserName: "Enter username",
        enterTeamName: "Enter team name",
        noSearchResult: "Enter team name. Try another keyword.",
        beyondLimit: "It exceeds the upper limit of 10,000",
        configSuccess: "Configured successfully",
        deleteConfirm: "Confirm deletion??",
        item: "item",
        noFilterSearchResult: "No corresponding search results. Please try another keyword.",
        character: "Enter service configuration name in no more than 50 characters",
        noErrorSpecialCharacters: "The following special characters are not allowed",
        isSyncing: "Synchronizing",
        jksFile: "JKS format",
        uploadJksFile: "Upload files in the JKS format",
        inputCertificatePassword: "Enter certificate password",
        address: "Enter address",
        modifySuuccess: "Modified successfully",
        agentPlaceholder: "Enter proxy service name in no more than 50 characters",
        inputTeamOrUser: "Enter username/team name for your search",
        addFilterSuccess: "Filtering conditions added successfully",
        modifyFilterSuccess: "Filtering conditions modified successfully",
        errorEmail: "Invalid email format",
        errorMobile: "Invalid mobile phone number format",
        bindingServerConfig: "Third-party binding service configuration",
        matchingRule: "Matching rule",
        mobile: "Mobile number",
        email: "Email",
        syncResult: "Synchronize results",
        newBinding: "New binding",
        failBinding: "Binding failed",
        account: "Account",
        bindingLogTitle: "List of binding configuration logs",
        inputAccount: "Enter account",
        signCongit: "Qrcode configuration",
        scan: "Qrcode configuration",
        qrcode: "Qrcode configuration",
        SSO: "SSO configuration",
        sso: "SSO configuration",
        scanName: 'Slug name',
        boxUrl: 'Access address of network disk',
        copyUrl: 'Copy address',
        identification: 'Match identification',
        appKeySecret: 'appKeySecret',
        ssoWarning: 'Because you have used the proxy service, the system cannot obtain the proxy server address. Therefore, when you use the network disk to access the address, you need to manually fill in the IP or address of the proxy service in XXX location, for example: https://lenovows.com/user/manage',
        agentWarning: 'A maximum of 1 configuration can be added to the proxy service',
        importWarning: 'Organization import service adds up to 1 configuration',
        authWarning: 'Login authentication service can add up to 1 configuration',
        schema: 'schema',
        userStatus: 'user status',
        probation:'probation',
        formal:'formal',
        temporary:'temporary',
        probationExtension:'probation extension',
        dismissal:'dismissal',
        resignation:'resignation',
        retirement:'retirement',
        invalid:'Invalid. Only official users are synchronized',
        importSealTeam:'Import seal team',
        yes:'yes',
        no:'no',
        relationship: 'relationship',
        appIdMobile: 'appIdMobile',
        appSecretMobile: 'appSecretMobile',
        applicationVoucher:'application voucher',
        applicationVoucherTitle:'configure the application credentials of the connection pin to obtain the basic information of the nailing user',
        scanLogin:'scan code to login',
        scanLoginTitle:'configure the authorization information of the nail scanning login application to realize the nail scanning code login on the network disk',
        mobileAuthorizedLogin:'mobile authorized Login',
        mobileAuthorizedLoginTitle:'configure the "mobile app access share" authorization information to enable the mobile end to log in through pinning authorization',
        kingdee: 'Kingdee',
        createSuperiorTeam: 'Create parent team automatically',
        createSuperiorOrg: 'Create parent department automatically',
        autCreateSuperiorTeam: 'The parent team will be created automatically when the added filter conditions are synchronized to the teams',
        autCreateSuperiorOrg: 'The parent department will be created automatically when the added filter conditions are synchronized to the departments',
        all: 'Select all',
        serviceList: 'Service list',
        searchSuccess: 'Success',
        uploadError: 'Error',
        confirmClose: 'Confirm Close?',
        confirmOperation: 'Confirm operation？',
        loading: 'loading...',
        allSuccess:'Success',
        startSuccess:'Success',
        closeSuccess:'Success',
        uploadSuccess:'Success',
        delConfirm: 'Are you sure you want to delete'
    },
    addUser: {
        title: "Add members",
        searchLable: "Search for or select members:",
        searchInput:"Search for a name, Email or department name",
        allSelected: "Total {0} members",
        selected: "{0} members selected",
        selectJoin: "Select members to be added",
        continue: "Users' organizational relationship will be changed if you add existing members. Are you sure you want to continue?",
    },
    batchImport: {
        bulk: "Import users in bulk",
        title: "Batch import",
        downloadTemp: "Step 1: download the template file",
        editTemp: "Step 2: edit the template file",
        uploadTemp: "Step 3: upload the edited file",
        downloadBtn: "Download",
        fileType:"xls or xlsx file",
        progress: "Users from the template are being imported. Please wait...",
        total: "Total {0} users",
        upSuccess: "{0} users have been imported successfully",
        upFailed: "Failed to import {0} accounts",
        user: "Username",
        mail: "Email for login",
        phone: "Mobile number",
        pwd:"password",
        org: "Department",
        state:"State",
        noFile: "No files have been uploaded",
        errorType: "{0} cannot be uploaded, because its file type is not allowed",
        emptyFile: "The file is empty",
        upSuccessTip: "Imported successfully",
        more: "The file is over 500 MB. Please use",
        client: "client",
        upload:"to upload",
        flashTip: "To use this function, you are required to install the Flash plugin. Click",
        here: "Here",
        install: "Install",
        force: "Force imported users to change initial passwords",
    },
    createUser: {
        title: "Create new user",
        org: "Department:",
        mail: "Email:",
        mailInput:"Please enter email",
        name: "Name:",
        nameInput:"Please enter user name",
        phone: "Mobile:",
        date: "Expiration:",
        setDate: "Add user expration day",
        seletDate: "Select a date",
        data: "Data Center:",
        space: "Storage:",
        spaceInput: "Enter the size of space",
        spaceTips: "It must not exceed the total space size",
        active: "An activation link is sent by email for the user to set password",
        set: "The password is to be set by the administrator",
        pwdTips: "The password should consist of at least two kinds of characters and be 6-32 characters in length",
        forbidPwd: "The account is prohibited from changing password",
        allowPwd: "Allowed to change password",
        firstLoginPwd: "First login change password",
        success: "User created successfully",
        phonePlaceholder: "Enter mobile phone number",
        area: "Search for countries/regions",
        areaNull: "No related countries or regions found",
        seletDateTips: "The account will not be able to login beyond this date",
    },
    userSet: {
        title: "User Setting",
        userType: "User type:",
        sended: "Sent",
        active: "Activated",
        noactive: "Inactive",
        sendEmail: "Invite to activate",
        pwd: "Password:",
        setPwd: "Modify password",
        inputPwd: "Please enter password",
        team: "Team:",
        invitation: "Invitation sent successfully",
        invitationSuccess: "An activation invitation can't be sent repeatedly within 1 hour",
        success: "User setting is successful",
        noData: "The space already contains data, you cannot change the data center?",
        confirmData: "You can change after the data migration",
        isData: "Sure to change?",
        yesData: "The deleted data cannot be restored after changing the data center",
        localUser: "Local Authentication",
        entUser: "Enterprise Authentication",
        thirdUser: "3rd Authentication",
        pwdTip:"Password setting is not supported for users of third-party app synchronization"
    },
    adminRole:{
        title: "Administrator role"
    },
    orgManage:{
        title: "Department management",
        createUser: "Create new user",
        addLocalUser: "Add existing users",
        batchUser:"Batch import",
        forze:"Freeze",
        unforze: "Unfreeze",
        batchSet: "Set up in bulk",
        search: "Search by email/name",
        userBatchSet: "Set up accounts in bulk",
        spaceErr:"Positive integer",
        deleteUserApproval:"This user is the only approver of the {0} directory approval rule. After deletion, the approval rule will adopt the default approver logic.",
        deleteUserApprovalMore:"This user is the only approver of the {0} and other directory approval rules. After deletion, the approval rules will adopt the default approver logic.",
        deleteUserOdc:"This user is the only link approver of the {0} directory in the offline document control. After deletion, the link approval rules of this directory will adopt the default approver logic.",
        deleteUserOdcMore:"This user is the only link approver of {0} and other directories in offline document control. After deletion, the link approval rules of these directory will adopt the default approver logic.",
        frozeUserApproval:"This user is the only link approver of the {0} directory in the offline document control. After freezing, the link approval rules of this directory will adopt the default approver logic.",
        frozeUserApprovalMore:"This user is the only link approver of {0} and other directories in offline document control. After freezing, the link approval rules of these directory will adopt the default approver logic.",
        frozeUserOdc:"This user is the only approver of the {0} directory approval rule. After freezing, the approval rule will adopt the default approver logic.",
        frozeUserOdcMore:"This user is the only approver of the {0} and other directory approval rules. After freezing, the approval rules will adopt the default approver logic.",
        deleteUserConfirm: "Are you sure you want to delete the selected user?",
        deleteUserConfirm2: "No folders in the current user's personal space are shared with others",
        deleteUserConfirm3: "If you delete the user, its personal space data will also be deleted and all permissions will be canceled.",
        confirm: "Apply",
        confirmDelete: "Confirm deletion",
        spaceNullErr:"The default user space can not be empty!",
        addOrg: "Add department",
        searchOrg: "Search",
        dissOrg: "Dissolve department",
        deleteOrg: "Delete department",
        renameOrg: "Rename department",
        level: "Hierarchy",
        orgName: "Name",
        orgNamePlaceholder: "Enter department name",
        dissOrgMsg: "You are about to dissolve the department and its sub-departments",
        dissOrgMsg2: "Members and sub-departments of the department will automatically become subordinate to the department at a higher level",
        deleteOrgMsg: "Are you sure to delete the department?",
        deleteOrgMsg2: "Sub-departments and users will be deleted",
        searchOrgNull: "No related departments found",
        selected: "Selected",
        members: "members",
        username:"Name",
        email:"Email",
        mobile:"Phone",
        dcId:'Data Center',
        quota:'Storage',
        ctime:"Create time",
        teamName:'Department',
        etime: "Expiration",
        login_time:'Last login time',
        exporting:"Exporting",
        cancel:"Cancel",
        all:"All",
        inDay: "Within {0} days",
        inDayOne: "Within {0} day",
        userState: "Status",
        opearte:"Operation",
        operationSet:"User Setting",
        operationMore:"More",
        modifyEmail: "Change Email",
        deleteUser: "Delete user",
        orgNullUser: "No members",
        choiceNullUser: "No related users",
        loginEmial:"Email",
        normal:"Normal",
        frozen:"Frozen",
        unfrozen: "Not frozen",
        activeted:"Activated",
        unactiveted:"Inactive",
        emialChange: "Email address changed to",
        deleteSuccess:"Delete Successfully",
        forzeApproval:"Are you sure you want to freeze the account?",
        errorTextMax: "The upper limit of characters that can be input has been reached",
        forzeConfirm: "Freezing the account will prohibit the account from logging in to zBox, but the account's permissions over data and teams in its personal space will be retained. Are you sure you want to freeze the account?",
        unforzeConfirm: "Are you sure you want to unfreeze the selected user?",
        forzeSuccess: "Unfrozen successfully",
        personNum: "member(s)",
        searchRolePlacehodler: "Enter keywords you want to search for",
        orgDeleteSuccess: "Department deleted successfully",
        export:'Export',
        customDialogHeader:"Items List",
        enterpriseCertifiedUsers:"Enterprise certified users",
        thirdPartyCertifiedUsers:"Third party certified users",
        exportOutTime:'Export timed out, please try again.',
        save:'Save',
    },
    adminList: {
        title: "Administrator settings",
        singleDelete: "Are you sure to delete the administrator?",
        multipleDelete: "Are you sure to delete the selected administrator?",
        addAdmin: "Add administrators",
        editAdmin: "Edit administrators",
        adminAuth: "Administration permissions",
        authScope: "Scope of control",
        adminEmpty: "No administrator yet",
        userName: "Username:",
        auth: "Permissions:",
        scope: "Control scope:",
        posTeam: "Designated team",
        allTeam:"All teams",
        posFile: "Part of the team files",
        allFile: "All files",
        searchTeam: "Search for team name",
        noSearchTeam: "No related teams found",
        control: "{0} teams are under control",
        addControl: "Add rule",
        nullControl: "No teams under control have been added",
        selectUser: "Select one user",
        noSelectAuth: "Permissions have not been selected yet",
        noSelectTeam: "Teams under control have not been selected yet",
        noAddTeam: "Teams under control have not been added yet",
        addAdminOk: "Administrator added successfully",
        chooseSame: "You cannot select the same team twice",
        beyondlimit: "Failed to add. The number of teams under control exceeds the upper limit.",
        selectAuthTip: "Click to select permissions",
        repeatAuth: "You cannot grant the same permission twice",
        inputUser: "Enter username or email address",
        nullUser: "No related username found",
        selectedTeam: "{0} teams have been selected",
        selectJoin: "Select teams to be added",
        searchNull: "No related users found",
        partFail: "Failed to delete a part of it. Please try again after checking the list.",
        controlNum: "Total {0} teams under control",
        controlTeamList: "List of teams under control",
        controlledTeams: "{0} teams under control",
    },
    transferAuth: {
        title: "Transfer permissions",
        searchTitle: "Network disk members",
        folderAuth: "Members sharing folders",
        noAuth: "No sharing members yet",
        folders: "{0} shared folders",
        userTooltip: "Someone among all users owns folders shared with others. You may:",
        userTooltip2: "1. Completely delete and clear data in its personal folders and shared folders",
        userTooltip3: "2. Transfer its shared folders to other users of zBox",
        userTooltip4: "{0} users own folders shared with others",
        transfer: "Transfer and delete",
        tips: "Selected user {0} owns folders shared with others",
        tipsOrg: "{0} in the department owns folders shared with others",
        tips2:'Deleting a user deletes their personal space data and cancels all permissions',
        tips3: "You may:",
        tips4: "If the user is completely deleted, its shared folders will also be deleted.",
        tips5: "You may transfer the shared folders to another user when deleting the user",
        tips6: "Select the shared folders to be transferred. Shared folders not selected will be completely deleted",
        selectUser: "{0} members selected",
        deleted: "Deleted",
        transferDeleted: "Transferred and deleted",
        delete: "Deleted completely",
        searchResult: "Search results:",
        folderUser:'Folder sharing member',
        userNull: "No related members found",
        userSuccessTip: "User permissions transferred and deleted successfully",
        userAllSuccess: "All operations succeeded",
        userUserSuccess: "Users deleted successfully",
        userOtherSuccess: "Some operations have taken effect",
    },
    synctask:{
        title: "Synchronization task",
        tips: "Synchronize files in the specified folder to another data center to archive data",
        openservice: "Call customer service at 400-898-7968 to subscribe",
        choosefile: "Select a folder",
        addtasktips: "You can currently add a maximum of {0} synchronization tasks",
        addtasktipshover: "{0} more synchronization tasks can be added each time a synchronization module is deployed",
        addtask: "Add synchronization tasks",
        taskFolder: "Synchronize the folder",
        dataCenter: "Data Center",
        taskTo: "Synchronized to",
        chooseDataCenter: "Select a data center",
        syncTiming: "Scheduled sync",
        chooseTime: "Select a point in time",
        folder:'Folder',
        syncDataCenter: "Synchronized the data center",
        createTime:'Create time',
        creater: "Creator",
        taskState: "Task status",
        operate:'Operation',
        notTask: "No synchronization tasks yet",
        editTask: "Modify synchronization tasks",
        syncFolder:'Sync folder',
        deleteTask: "Delete synchronization tasks",
        confimTask: "Are you sure you want to delete this synchronization task?",
        taskLog: "Task log",
        change: "Modify",
        exception: "Abnormal",
        normal:'Normal',
        taskSuccess: "Task synchronization created successfully",
        taskChangeSuccess:'Successful revision',
        notSameTime: "You must not select the same time",
        noModules: "No synchronization module was found. Please deploy the synchronization module before adding tasks",
    },
    app: {
        'thirdApp': 'Third party applications',
        'appManager': 'Application management',
        'createApp': 'Create application',
        'editApp': 'Edit',
        'nodesc': 'No description has been added yet',
        'appName': 'Application name',
        'appDesc': 'Application description',
        'appIcon': 'Application icon',
        'ipManage': 'IP management',
        'addIp': 'Add allowed IP',
        'appNameTip': 'Please enter the application name, no more than 50 characters',
        'addIpDesc': 'Fill in the allowed IP addresses. Please separate multiple IPs with a comma. IP segment It is supported to fill in the IP segment. The IP start address and end address are separated by "-"',
        'rateLimit': 'Interface request frequency limit',
        'setRateLimit': 'Set interface request frequency limit',
        'rateLimitDesc': 'In order to prevent server load exception caused by frequent application calls, there is a frequency limit for each server interface call by default. When this limit is exceeded, the corresponding error code will be returned when calling the corresponding interface.',
        'rateLimitNumber': 'Need to prompt upper limit number',
        'rateLimitUnit': 'times/min',
        'appVoucher': 'Application credentials',
        'baseInfo': 'Basic information',
        'appAvatar': 'Application Icon',
        'editInfo': 'Edit',
        'backUp': 'Back to application management',
        'deleteApp': 'Delete',
        'voucher': 'Credentials and basic information',
        'authManage': 'Authority management',
        'createSuccess': 'createSuccess',
        'createError': 'createError',
        'modifySuccess': 'Edited successfully',
        'modifyError': 'Edited failed',
        'delSuccess': 'Deleted successfully',
        'delError': 'DeleteError',
        'modifyAuthSuccess': 'Modify Authority Success',
        'modifyAuthError': 'Modify Authority Error',
        'deleteConfirm': 'Delete confirmation',
        'appNumLimit': 'Cannot create application. The number of applications has reached the upper limit.',
        'ipFormatError': 'IP range format error',
        'deleteConfirmTitle': 'Please confirm whether to delete this application?',
        'deleteDesc': 'Please check the application information. It cannot be restored after deletion, and the credential will be invalid',
        'imgFormatLimit': 'Only supports JPG or PNG',
        'imgBulkLimit': 'The icon size must be less than 120KB',
        'imgSizeLimit': 'The icon must be 240*240px or more',
        'imgTip': 'Please upload an icon without rounded corners, please confirm the format is JPG/PNG, the pixel is 240*240px or more, the ratio is 1:1, and the size is within 120kb',
        'appNameRequired': 'Application name cannot be empty',
        'appNameIsExit': 'Application name already exists',
        'ipRequired': 'Please add access IP',
        'appDescTip': 'Please enter the description, no more than 200 characters',
        'appVoucherDesc': 'The application credential contains two fields, Appkey and AppSecret. This field is the credential information that needs to be passed when calling the API. Users should keep it properly.',
        'baseInfoDesc': 'Basic information includes application name, description and icon. Users can modify the information as needed.',
        'ipDesc': 'In order to prevent the connection of unknown IP, please add the IP addresses allowed to access the application. Unknown IP cannot be connected to the application.',
        'authDesc': 'You can management the interface capabilities that the application can call. The selected authority is the callable interface.',
        'rateDesc': 'In order to prevent frequent calls which may cause loader exceptions, each server interface request has a frequency limit. When this limit is exceeded, the corresponding error code will be returned.',
        'rateCount': 'Interface request frequency limit is the maximum number of requests per minute. The upper limit that can be set is {0} times/min.',
        'rateLimitTip': 'The upper limit that can be set is {0}',
        'intSpace': 'Enter a positive integer for space size',
        'rateRequired': "Application frequency limit cannot be empty",
        'ratePlaceholder': 'Please enter the content'
    },
    document: {
        header: {
            title: 'OpenDockingPlatform',
            api: 'ServiceAPI',
            login: 'login',
        },
        api_file_req_to_movepath: 'Move destination path',
        api_file_req_to_movepathtype: 'Move path type: {ent: enterprise space, self: self space}',
        api_file_req_tofilename: 'File name (with file suffix type, for example: new name.txt)',
        api_delivery_delete_name: 'Delete link',
        api_delivery_delete_desc:'Delete the link according to the link code',
        api_delivery_create_name: 'Create or update links',
        api_delivery_create_desc: 'Create or update the link. When updating the link, you need to pass in the link code',
        api_file_preview_name:'Get the file online preview address',
        api_file_preview_desc:'Obtain the preview address of the file according to the file id and version information.',
        api_file_chunks_desc: 'To prevent the connection from being interrupted unexpectedly and to provide the function of resuming the upload at a breakpoint, large files need to be uploaded in several small chunks.The size of a "chunk" file is 4MB. When dividing a large file into chunks, you should start from the beginning, record every 4MB of data as a file chunk, and calculate the SHA-256 value of each chunk of data as a Hash. If the last chunk is less than 4MB, there is no need to fill it.After the chunk is completed, the following three interfaces should be called in sequence.',
        api_file_chunked_byopsauth_desc: 'First call the Get data center address interface to obtain the upload address and session, and then call the following interface. You need to use the server address returned by the Get data center address interface as the upload domain name.',
        api_file_uploadbyopsauth_desc: 'First call the Get data center address interface to obtain the upload address and session, and then call the following interface. You need to use the server address returned by the Get data center address interface as the upload domain name.',
        api_file_rename_name:'Rename file',
        api_file_rename_desc:'Rename file',
        api_file_move_name:'Move files',
        api_file_move_desc:'Move the file to the specified folder.',
        UpdateTimeValue: 'February 26, 2021',
        updateTime: 'updateTime',
        Summary: 'Summary',
        ProductGuide: 'ProductGuide',
        IntroductionToTerms: 'IntroductionToTerms',
        usageMethod: 'UsageMethod',
        getToken: 'GetToken',
        useToken: 'UseToken',
        GlobalReturnCode: 'GlobalReturnCode',
        InterfaceDesc: 'InterfaceDesc',
        baseInfo: 'BaseInfo',
        requestType: 'RequestType',
        requestAddress: 'RequestAddress',
        requestParam: 'RequestParam',
        param: 'Param',
        type: 'Type',
        required: 'Required',
        place: 'Place',
        desc: 'Description',
        default: 'Default',
        requestExamples: 'RequestExamples',
        responseParam: 'ResponseParam',
        responseExample: 'ResponseExample',
        yes: 'Yes',
        no: 'No',
        file: 'File',
        delivery: 'Delivery',
        team: 'Team',
        user: 'User',
        "requestExamples": "RequestExamples",
        "responseParam": "ResponseParam",
        "responseExample": "ResponseExample",
        "GetFileList": 'Get the file list',
        "QueryFileInfor": "Query file information",
        "GetFlieInfpById": "Get file information by id",
        "GetHistoryApi": "获取历史版本接口",
        "UpdateFile": "Upload file",
        "FileBlock": "File chunks",
        "GetHashforUpdateFile": "Get the hash list of file chunks that need to be uploaded",
        "UpdateFileBlock": "Upload file chunk",
        "CommitFileUpdate": "Submit file upload",
        "GetDataCore": "Get data center address",
        "Update(dataCore)": "Upload file(data center)",
        "FileBlock(dataCore)": "File chunks(data center)",
        "CheckFileBlock": "Judge the existence of file chunk",
        "UpdateDataBlock": "Upload file chunks",
        "CommitFile": "Submit file",
        "DownloadFileById": "Download file (file id)",
        "DownloadFileByPath": "Download file (file path)",
        "CreateFolder": "Create folder",
        "DeleteFile": "Delete File",
        "CopyFile": "Copy files",
        "MoveFile": "Move files",
        "RenameFile": "Rename file",
        "GetPreviewAddress": "Get the file online preview address",
        "delivery": "Links",
        "CreateDelivery": "Create or update links",
        "DeleteDelivery": "Delete link",
        "GetDeliveryInfo": "Get link information",
        "GetDeliveryList": "获取外链列表",
        "team": "Team",
        "CreateTeam": "Create team",
        "GetTeamList": "Get team list",
        "GetTeamInfo": "Get team information",
        "UpdateTeamInfo": "Update team information",
        "DeleteTeam": "Delete team",
        "user": "User",
        "CreateUser": "Create users",
        "GetUserList": "Get user list",
        "GetUserInfo": "Take obtain user information",
        "UpdateUserInfo": "Update user information",
        "BatchFrozenUser": "Batch freeze users",
        "BatchUnfreezeUser": "Batch unfreezing users",
        "CreateTeamUserRelation": "Create team user relationships",
        "DeleteTeamUserRelation": "Delete team user relationship",
        "api_user_info_name":"Take obtain user information",
        "api_user_info_desc":"Get user information according to user ID",
        "api_user_update_name":"Update user information",
        "api_user_update_desc":"Update the user information according to the user ID.",
        "api_user_batchfreeze_name":"Batch freeze users",
        "api_user_batchfreeze_desc":"Freeze users in batch according to user ID list.",
        "api_user_batchactivate_name":"Batch unfreezing users",
        "api_user_batchactivate_desc":"Activate users in batch according to user ID list.",
        "api_user_teamcreate_name":"Create team user relationships",
        "api_user_teamcreate_desc":"Add the user to the designated team.",
        "api_user_teamdelete_name":"Delete team user relationship",
        "api_user_teamdelete_desc":"Delete the user from the specified team.",
        "api_authorization":"The format is bearer [token]",
        "api_manager_authorization":"This interface can only be called by using the token applied by the user with the identity of network disk administrator.",
        "api_contenttype_form":"Must be application/x-www-form-urlencoded",
        "api_file_chunk_uploadchunk_name": 'Upload file chunk',
        "api_file_chunk_uploadchunk_desc": 'This interface is used to upload file chunks. To upload a file chunk, you need to provide the SHA-256 value of the file chunk, the body of the file chunk and the previously obtained uploadId.',
        "api_contenttype_multipart":"Must be multipart/form-data",
        "api_file_req_chunkhash": 'The SHA-256 value of file chunk',
        "api_file_req_uploadid": 'Upload Id, returned by the interface to get the chunk list of the file to be uploaded',
        "api_file_req_filedata": 'Chunk file body',
        "api_file_req_path": 'Path',
        "api_file_req_pathtype": 'Path type: ent—enterprise space, self—self space',
        "api_errorcode": 'Error code, success: 0',
        "api_errmsg": 'Error description, success: ok',
        "api_file_res_hash": 'The hash of the file chunk uploaded this time',
        "api_file_res_uploadId": 'The upload tag id',
        "api_file_res_status": 'Status',
        "api_team_req_id":"team ID",
        "api_user_req_id":"user ID",
        "api_user_req_email":"email",
        "api_user_req_mobile":"phone number",
        "api_user_req_password":"password",
        "api_user_req_quota":"User's personal place size（unit：Bytes）",
        "api_user_req_username":"user name",
        "api_user_req_uids":"User ID. Use commas to separate multiple IDs.",
        "api_errcode":"Error code, success: 0",
        "api_errmsg":"Error description, success: OK",
        "api_user_res_id":"User ID. This item is an immutable identification of user identity. After creating a user, this field should be properly saved for subsequent modification.",
        "api_user_res_email":"email",
        "api_user_res_mobile":"cell-phone number",
        "api_user_res_quota":"User personal place size Unit: bytes ",
        "api_user_res_status":"User status: Frozen - 1, inactive 0, activated 1, expired - 2, deleted - 3",
        "api_user_res_used":"The amount of personal space users have used（Unit: bytes）",
        "api_user_res_username":"user name",
        "api_user_res_userslug":"login name",
        "api_user_res_batch_list":"Array of batch operation results.",
        "api_user_res_batch_list_desc":"A single batch operation model (batchuserop) is",
        "api_user_res_batch_list_code":"Status code",
        "api_user_res_batch_list_message":"Result information",
        "api_user_res_batch_list_status":"Status code, 200 is success.",
        "api_user_res_batch_list_type":"type",
        "api_user_res_batch_list_uid":"user ID",
        "api_user_res_createmember":"All user information under the current team.",
        "api_user_res_createmember_desc":"The structure of team user model :",
        "api_user_res_createmember_ctime":"Creation time",
        "api_user_res_createmember_fromdomainaccount":"Confirm domain user",
        "api_user_res_createmember_role":"role",
        "api_user_res_createmember_team":"Team name (non full path)",
        "api_file_list":"Get the file list",
        "api_file_list_desc":"Get the list of files in the specified path.",
        "api_file_info_byId":"Get file information by id",
        "api_file_info_byId_desc":"Get file information by the specific id。",
        "api_file_info":" Query file information",
        "api_file_info_desc":"Get the file information of the specified path.",
        "api_file_revisions":"获取历史版本接口",
        "api_file_revisions_desc":"获取指定id的文件历史版本信息",
        "api_file_content":"Upload file ",
        "api_file_content_desc":"Call this interface to upload files to the specified path.",
        "api_file_need_upload_chunks":"Get the hash list of file chunks that need to be uploaded",
        "api_file_need_upload_chunks_desc":"Some file chunks may already exist in the network disk, so these file chunks do not need to be transferred again in this transmission. Therefore, the file chunk should record the corresponding relationship between the file chunk and the SHA-256 value of the chunk, and then call this interface to get the file chunk that needs to be transferred in this transmission.Hash here specifically refers to the SHA-256 algorithm.",
        "Authorization_field_desc":"The format is bearer [token]",
        "Authorization_field_desc_2": "The format is bearer [token] This interface can only be called by using the token applied by the user with the identity of network disk administrator.Alternatively, users who do not have administrator rights can also enter their own uid calls.",
        "Authorization_field_desc_3": "The format is bearer [token] This interface can only be called with a token requested as a user with the identity of a network disk administrator.",
        "ContentType_field_desc":"Should be application/x-www-form-urlencoded",
        "path_type_field_desc":"Path type: ent—enterprise space, self—self space",
        "sort_field_desc":"Sort by: asc—normal, desc--reverse",
        "order_by_field__desc":"Sort requirement:name: file name, size: file size, mtime: update",
        "page_num_field_desc":"Page number(Positive)",
        "page_size_field_desc":"Number per page, value range（0，999）",
        "errcode_field_desc":"Error code, success: 0 ",
        "errmsg_field_desc":"Error description, success: ok ",
        "fileModelList_field_desc":"File list (see single file model) ",
        "total_field_desc":"Number of files",
        "desc_field_desc":"File notes",
        "dir_field_desc":"Is it a folder",
        "modified_field_desc":"The last modified time",
        "neid_field_desc":"File id",
        "nsid_field_desc":"Namespace id",
        "path_field_desc":"File path",
        "pathType_field_desc":"Path type: ent—enterprise space, self—self space",
        "rev_field_desc":"File version",
        "size_field_desc":"File size",
        "creator_field_desc":"File creator",
        "creatorUid_field_desc":"The id of file creator",
        "updator_field_desc":"File updator",
        "updatorUid_field_desc":"The id of file updator",
        "filedata_field_desc":"File body",
        "chunk_hashes_field_desc":"The block hash list，such as：['b2f09e4c62a6e43a2d445759d5f4cf6b16886d9dba68d1be43abd6127aeb96d1','d8bf7676c69f0c96d5e15469c70b16bbf696f086705060088d138496f7450a51']",
        "neededBlock_field_desc":"The SHA-256 value of the file chunk to be uploaded.",
        "uploadId_field_desc":"The upload tag id, which is equivalent to the 'pre-identification' of the file, will be used in subsequent operations of uploading the file chunk.",
        api_user_create_name:'Create users',
        api_user_create_desc:'Create a new user',
        api_contenttype_form:'must be application/x-www-form-urlencoded',
        api_manager_authorization:'The format is bearer [token] This interface can only be called with a token requested as a user with the identity of a team administrator.',
        api_user_email:'email',
        api_user_phone:'cell-phone number',
        api_user_password:'password ',
        api_user_quota:'User personal place size Unit: bytes',
        api_user_status:'User status: {frozen: - 1, activated: 1}',
        api_user_name:'User name',
        api_user_slug:'Login name',
        api_errorcode:'Error code, success: 0',
        api_errmsg:'Error description, success: OK',
        api_user_id:'User ID. This item is an immutable identification of user identity. After creating a user, this field should be properly saved for subsequent modification user id',
        api_user_used:'User personal place size Unit: bytes',
        api_user_getlist_name:'Get user list',
        api_user_getlist_desc:'Paging to get user information.',
        api_user_getlist_key:'Query criteria. It can be login name, user name or email fragment.',
        api_user_getlist_num:'pagination',
        api_user_getlist_size:'Quantity per page, value range (0，1000)',
        api_user_getlist_total:'result number',
        api_user_getlist_userList:'User array.',
        api_team_list_name:'Get team list',
        api_team_list_desc:'Get sub team list information according to team ID.',
        api_team_id:'team ID',
        api_team_array:'team Array',
        api_delivery_res_accessmode: 'Authority',
        api_delivery_res_code: 'Long freeman code',
        api_team_total:'Number of results',
        api_team_teamlist:'Team array',
        api_team_description:'team description',
        api_team_memberlimit:'Maximum team size',
        api_team_path:'Team path, e.g. / AAA',
        api_team_quota:'Team space unit: bytes',
        api_team_name:'Team name, e.g. / AAA',
        api_team_get_name:'Get team list',
        api_team_get_desc:'Get sub team list information according to team ID.',
        api_team_update_name:'Update team information',
        api_team_update_desc:'Update team information according to team ID.',
        api_contenttype_form:'must be application/x-www-form-urlencoded',
        api_team_delete_name:'Delete team',
        api_team_delete_desc:'Delete the team according to the team ID.',
        api_team_delete_password:'Current user identity password. Delete team operation needs secondary verification，need to enter password.',
        api_file_chunk_commitchunkupload_idt_name: 'Submit file',
        api_file_chunk_commitchunkupload_idt_desc: 'This interface is used to end the entire chunk upload process. Before calling this interface, please make sure that all file chunks have been uploaded. The calling interface needs to provide the total file size, the SHA-256 value list of the corresponding file chunk, the path and path type of the file into the network disk.',
        api_box_sessionid:'Sessionid',
        api_file_req_filepath: 'The upload path',
        api_file_req_overwrite: 'Whether overwrite or not',
        api_file_req_isfilecommit: 'Whether to submit files',
        api_file_req_bytes: 'Total file size',
        api_file_req_hashes:'File chunk hash list',
        api_file_req_path1: 'path',
        api_file_req_range: 'Support byrange download format：bytes=0-4194304 bytes=4194304',
        api_file_req_pathtype: 'Path type: ent—enterprise space, self—self space',
        api_file_name: 'File name (for example: a.txt)',
        api_file_copy_name: 'Copy files',
        api_file_copy_desc: 'Copy the file to the specified folder.',
        api_file_req_fromneid: 'File ID',
        api_file_req_topath: 'Copy destination path',
        api_file_req_topathtype: 'Copy path type: ent—enterprise space, self—self space',
        api_errorcode: 'Error code, success: 0',
        api_errmsg: 'Error description, success: OK',
        api_file_create_folder_name: 'Create folder',
        api_file_create_folder_desc: 'Create a folder with the specified path.',
        api_file_req_path: 'Full path (for example: /a/b/c)',
        api_file_req_pathtype: 'Path type: ent—enterprise space, self—self space',
        api_file_res_desc: 'File notes',
        api_file_res_modified: 'Last Modified',
        api_file_res_neid: 'File ID',
        api_file_res_path: 'File path',
        api_file_res_pathtype: 'Path type: ent—enterprise space, self—self space',
        api_file_res_rev: 'File version',
        api_file_res_size: 'File size',
        api_file_res_creator: 'Creator',
        api_file_res_creatorUid: 'Creator id',
        api_file_res_updator: 'Updator',
        api_file_res_updatorUid: 'Updator id',
        api_file_delete_name: 'Delete File',
        api_file_delete_desc: 'Delete files based on file id.',
        api_file_req_neid: 'File id',
        api_file_req_nsid: 'Namespace id',
        api_file_download_by_id_name: 'Download file (file id)',
        api_file_download_by_id_desc: 'Download the file with the specified id.',
        api_file_req_range: 'Support byRange download',
        api_file_req_neid: 'File id',
        api_file_req_rev: 'File version, blank refers to the latest version',
        api_file_res_return_desc: 'The return is a file stream.',
        api_file_download_by_path_name: 'Download file (file path)',
        api_file_download_by_path_desc: 'Download the file in the specified path.',
        api_file_req_range: 'Support byRange download',
        Format: 'bytes=0-4194304,bytes=4194304',
        api_file_req_path: 'File path',
        api_file_req_pathtype: 'Path type: ent—enterprise space, self—self space',
        api_file_req_rev: 'File version, blank refers to the latest version',
        api_file_res_return_desc: 'The return is a file stream.',
        api_teamCreate_desc: 'Create a new team',
        api_teamCreate_authorization: 'The format is bearer [token]. This interface can only be called with a token requested as a user with the identity of a team administrator.',
        api_teamCreate_authorization_2: 'The format is bearer [token]. This interface can only be called with a token requested as a user with the identity of a team administrator',
        api_teamCreate_authorization_3: 'The format is bearer [token]. This interface can only be called with a token requested as a user with the identity of a network disk administrator.',
        api_teamCreate_contentType: 'Must be application/x-www-form-urlencoded',
        api_teamCreate_description: 'Team description',
        api_teamCreate_member_limit: 'Maximum number of teams (no control of sub teams)',
        api_teamCreate_name: 'Team name, e.g. / AAA',
        api_teamCreate_quota: 'Team place in bytes (must be a multiple of 1048576)',
        api_teamCreate_regin_id: 'Data center Id',
        api_teamCreate_description_explain: 'Team description',
        api_teamCreate_id_explain: 'Team ID',
        api_teamCreate_member_limit_explain: 'Maximum team size',
        api_teamCreate_path_explain: 'Team path, e.g. / AAA',
        api_teamCreate_quota_explain: 'Team space unit: bytes',
        api_teamCreate_region_id_explain: 'Data center ID',
        api_develiy_get_info: 'Get link information',
        api_develiy_get_info_desc: 'Obtain link information according to the code',
        api_develiy_get_info_Authorization: 'The format is bearer [token]',
        api_develiy_get_info_code: 'Link code',
        api_develiy_get_info_accessMode: 'Authority',
        api_develiy_get_info_longCode: 'Long freeman code',
        api_develiy_get_info_counterDownload: 'Download counter',
        api_develiy_get_info_counterPreview: 'Number of previews',
        api_develiy_get_info_counterUpload: 'Numbers of uploading times',
        api_develiy_get_info_ctime: 'Creating time',
        api_develiy_get_info_description: 'Link description',
        api_develiy_get_info_expiration: 'Expiration time',
        api_develiy_get_info_hasPassword: 'Whether need to input password. Default : false',
        api_develiy_get_info_id: 'Main key',
        api_develiy_get_info_mimeType: 'File type',
        api_develiy_get_info_mode: 'Permission list',
        api_develiy_get_info_mtime: 'Modified time',
        api_develiy_get_info_password: 'Password',
        api_develiy_get_info_path: 'Link path',
        api_develiy_get_info_type: 'Type',
        api_develiy_get_info_url: 'Open address',
        api_get_token: 'Get token',
        api_use_token: 'Using token',
        api_token_field_desc: 'The format is Basic base64([appKey]:[appSecret]) For example, for appKey=aaa and appSecret=bbb, you need to type out "aaa:bbb" first, and then base64 encode, the final request header is Authorization: Basic YWFhOmJiYg==',
        api_token_path_field_desc: 'Fixed value here: client_with_su',
        api_token_path_field_desc_scope: 'The range of operations that the application can do to the user. The fixed value all is required here',
        api_token_slug: 'User login name. This indicates which user can call the API on behalf of the token generated.',
        api_get_token_error: 'Fail to request the token:',
        api_token_error: 'Token expired or do not exist:',
        api_token_scope: 'Token expired or do not exist:',
        api_token_token_type: 'Fixed as bearer currently.',
        api_token_access_token: 'Fixed as bearer currently.',
        api_token_expires_in: 'The valid time of the token.',
        api_token_content_code: 'The valid time of the token.',
        api_token_cankao: 'reference',
        api_token_yuanyin: 'reason',
        api_token_chenggong:'Request succeeded',
        api_token_shibai:'Parameter error',
        api_token_yichang:'Parameter error',
        api_token_jinzhi:'Operation is prohibited',
        api_token_bucunzai:'The requested entity does not exist',
        api_token_buyunxu:'The method specified in the request is not allowed',
        api_token_chongtu:'The requested resource does not meet the prerequisites',
        api_token_weimanzu:'Resource requested in conflict',
        api_token_cuowu:'Service internal error',
        api_token_fanhui: 'Return fields',
        api_token_zhuyishixiang: 'Attention',
        api_token_zhuyishixiang_decs1: 'Developers need to cache access_token for subsequent interface calls (note: this interface will be intercepted if called frequently). When the access_token becomes invalid or expires, it needs to be obtained again.',
        api_token_zhuyishixiang_decs2: 'The validity time of the access_token is conveyed by the returned expires_in. Repeated acquisition of the token for the same user within the validity period of the same application will return the same result, and the acquisition after the expiration will return a new access_token.',
        api_token_zhuyishixiang_decs3: 'Due to operating strategies, there is no guarantee that the token will continue to be valid during the validity period. Developers should implement the logic of reacquiring access_token when it becomes invalid.',
        api_token_zhuyishixiang_decs4: 'The access_token reserves at least 512 bytes of storage space.',
        api_use_token_decs1: 'After obtaining the token, you can use the API provided by the open platform. When calling the API, you only need to add the Authorization request header as shown below.',
        api_use_token_decs2: 'Authorization: bearer [token]',
        api_use_token_decs3: 'Please replace [token] with the token content obtained before.',
        api_token_subtitle: 'Obtaining the token is the first step to call the open platform API. Almost all business APIs need to rely on the token to determine the identity of the caller (application, app) and user (user).',
        api_chanpinzhinan_decs1: 'Filez open platform is a service platform that provides enterprises with secondary development based on the basic business and functions of zBox, and provides enterprises with intelligent and safe multi-person file editing, collaboration and management solutions. The platform targets at enterprise or third-party developers and is connected with the internal system of the enterprise through an open interface to meet the enterprise customized file management needs.',
        api_chanpinzhinan_decs2: 'Filez provides APIs in four parts: file operation, link management, team management, and user management. Enterprises can use these APIs to empower their file management.',
        api_mingcijieshao1: '1.	Application（app）',
        api_mingcijieshao_decs1: 'An application (app) represents the caller of open platform APIs. Currently, the open platform API does not provide an anonymous access mechanism, so you need to hold application identity information (see the token explanation for details) to use the API provided by the open platform.',
        api_mingcijieshao_decs2: 'The application identity information contains two fields:',
        api_mingcijieshao_decs3: '“appKey” is used to uniquely identify the information of an application (equal to a user name)',
        api_mingcijieshao_decs4: '“appSecret” is used to prevent fraudulent use of application information (equal to a password)',
        api_mingcijieshao_decs5: 'The open platform provides these two fields, and users should keep them properly. To ensure security, appSecret should only be passed when called in the background.。',
        api_mingcijieshao2: '2.	User（user）',
        api_mingcijieshao_decs7: 'Unless otherwise specified in this document, it refers to filez Box users.',
        api_mingcijieshao3: '3.	Token（token）',
        api_mingcijieshao_decs8: 'The token is the credential information that needs to be passed to call all APIs. If you want to call the API, you need to bring application information and user information to the specified endpoint to apply for a token (see the following section for details). This means that one token corresponds to one application information and one user information. If you want to call the API with several different users  identities, you need to apply for a token once for each user.',
        api_mingcijieshao4: '4.	Parameters',
        api_mingcijieshao_decs9: 'Calling the API requires passing parameters. In subsequent chapters, we use square brackets to represent the parameters that need to be passed. For example, token=[token], which means you need to replace [token] with the parameters that need to provide. In addition, some parameters need to be processed by specific functions. We use italics for processing functions, such as base64([token]), which means that after the token parameter is passed, base64 encoding is performed again.',
        api_file_chunk_req_path: 'Path',
        api_team_region_id: 'Data center ID',
        api_file_res_previewurl:'File preview URL',
        api_file_chunk_commitchunkupload_name: 'Submit file upload',
        api_file_chunk_commitchunkupload_desc: 'This interface is used to end the entire file chunk upload process. Before calling this interface, please make sure that all file chunks have been uploaded. The interface needs the total file size, the SHA-256 value list of the corresponding file block, the path and path type of the file into the network disk.',
        api_authorization: 'The format is bearer [token]',
        api_contenttype_form: 'Must be application/x-www-form-urlencoded',
        api_file_req_bytes: 'Total file size',
        api_file_req_chunkhashes: 'File chunk has list',
        api_file_req_path: 'Full path (for example: /a/b/c)',
        api_fileopsauth_req_path: 'Upload path (full path, such as: /a/b）',
        api_file_req_pathtype: 'Path type: ent—enterprise space, self—self space',
        api_errorcode: 'Error code, success: 0',
        api_errmsg: 'Error description, success: ok',
        api_file_res_metadata: 'The metadata information of the uploaded file, the structure is the file model',
        api_file_res_uploadId: 'Upload id',
        api_file_res_neededBlock: 'Chunks to be uploaded',
        api_file_chunk_commitchunkupload_file_name: 'The structure of a single file model (File) is as follows:',
        api_file_res_desc: 'File notes',
        api_file_res_dirType: 'Is it a folder',
        api_file_res_modified: 'The last modified time',
        api_file_res_neid: 'File id',
        api_file_res_path: 'File path',
        api_file_res_pathType: 'Path type: ent—enterprise space, self—self space',
        api_file_res_rev: 'File version',
        api_file_res_size: 'File size',
        api_file_fileopsauth_name: 'Get data center address',
        api_file_fileopsauth_desc: 'Judge whether it can be uploaded, and if it can be uploaded, return the upload data center server address.',
        api_authorization: 'The format is bearer [token]',
        api_file_req_full_path: 'Upload path (full path, such as: /a/b）',
        api_file_req_pathtype: 'Path type: ent—enterprise space, self—self space',
        api_errorcode: 'Error code, success: 0',
        api_errmsg: 'Error description, success: ok',
        api_file_res_region: 'Data center address',
        api_file_res_session: 'sessionid',
        api_file_uploadbyopsauth_name: 'Upload file(data center)',
        api_file_uploadbyopsauth_desc: 'First call the Get data center address interface to obtain the upload address and session, and then call the following interface. You need to use the server address returned by the Get data center address interface as the upload domain name (replace the part marked in red in the request example).',
        api_box_sessionid: 'Sessionid',
        api_contenttype_multipart: 'Must be multipart/form-data',
        api_file_req_uploadpath: 'Upload path (full path, such as: /a/b/test.txt)',
        api_file_req_overwrite: 'Whether to overwrite the original file',
        api_file_req_language: 'Language',
        api_file_req_source: 'Source',
        api_file_req_pathtype: 'Path type: ent—enterprise space, self—self space',
        api_file_req_file: 'File body',
        api_file_res_result: 'Upload result',
        api_file_res_uploadpath: 'Upload file full path',
        api_file_res_isdir: 'Is it a folder',
        api_file_res_owneruid: 'The user id of the owner',
        api_file_res_modified: 'The upload time',
        api_file_res_creatoruid: 'The id of the creator',
        api_file_res_neid: 'The file id',
        api_file_res_rev: 'The file version',
        api_file_res_regionid: 'The data center address id',
        api_file_res_pathtype: 'The path type',
        api_file_res_size: 'The file size',
        api_file_res_updatoruid: 'The id of the updator',
        api_file_res_mimetype: 'The file type',
        api_file_res_bytes: 'Number of bytes',
        api_file_res_hash: 'File hash value',
        api_file_res_desc: 'description',
        api_file_chunked_byopsauth_name: 'File chunks(data center)',
        api_file_chunked_byopsauth_desc: 'First call the Get data center address interface to obtain the upload address and session, and then call the following interface. You need to use the server address returned by the Get data center address interface as the upload domain name.',
        api_file_chunked_checkblockbyopsauth_name: 'Judge the existence of file chunk',
        api_file_chunked_checkblockbyopsauth_desc: 'This interface determines whether the file chunk uploaded by the user exists and returns the hash information of the file chunks to be uploaded.',
        api_box_sessionid: 'Sessionid',
        api_contenttype_form: 'Must be application/x-www-form-urlencoded',
        api_file_req_uploadpath: 'Upload path (full path, such as: /a/b/test.txt)',
        api_file_req_pathtype: 'Path type: ent—enterprise space, self—self space',
        api_file_req_bytes: 'Total file size',
        api_file_req_hashes: 'File chunk hash list',
        api_file_res_chunkedneededblock: 'The SHA-256 value of the file chunk to be uploaded',
        api_file_res_chunkeduploadid: 'The upload tag id, which is equivalent to the "pre-identification" of the file, will be used in subsequent operations of uploading the file block.',
        api_file_chunked_uploadbyopsauth_name: 'Upload file chunks',
        api_file_chunked_uploadbyopsauth_desc: 'This interface is used to upload file blocks. To upload the data chunk, one should provide the SHA-256 value.',
        api_box_sessionid: 'Sessionid',
        api_contenttype_multipart: 'Must be multipart/form-data',
        api_file_req_chunkedhash: 'The SHA-256 value of the file chunk',
        api_file_req_chunkeduploadid: 'Upload Id, returned by the interface to get the file chunk list to be uploaded',
        api_file_req_chunkedoffset: 'Offset of upload hash chunk',
        api_file_res_chunkedhash: 'The hash of the file chunk uploaded this time.',
        api_file_res_chunkeduploadid: 'The upload id',
        api_file_res_chunkedstatus: 'Status',
        api_file_req_path_2: 'Path',
        api_file_req_path_3: 'file path (Full path, for example: /a/b/c)',
    },
    // 安全连接翻译开始
    "安全链接": "Secure links",
    "链接安全管控": "Link security policy",
    "管控目录的文件": "Files in the control directory",
    "如果允许管控目录内的文件移动或复制，会导致文件不受此规则管控": "If files in the control directory are allowed to be moved or copied, the files will not be controlled by this rule",
    "禁止移动": "Moving prohibited",
    "禁止复制": "Copying prohibited",
    "链接最长有效期": "Maximum validity period of the link",
    "目录所在路径": "Directory path",
    "禁止重命名": "Renaming prohibited",
    "联系客服开通服务，请拨打 400-898-7968": "Call customer service at 400-898-7968 to subscribe",
    "如果管控目录所在路径被重命名，会导致此管控规则失效": "If the path of the directory under control is renamed, it will cause the control rule to become invalid",
    "目录链接管控规则": "Directory link control rules",
    "规则说明": "Rule description",
    "添加管控规则": "Add rule",
    '管控白名单': 'Whitelist',
    '天': 'day(s)',
    '年': 'years',
    //sp2-start
    "禁止上传": "Uploading prohibited",
    "禁止下载": "Downloading prohibited",
    "禁止预览": "Previewing prohibited",
    "仅内部成员可用": "For internal members only",
    "最长有效期": "Maximum validity period",
    "请输入正整数": "Enter positive integer",
    "生成链接必须添加密码": "Password must be added for generating links",
    "最多阅读次数": "Maximum number of viewing times",
    "最长阅读时长": "Longest viewing duration",
    "文档只读": "Read-only",
    "禁止打印": "Printing prohibited",
    "失效后删除": "Delete after expiration",
    "添加水印": "Add watermark",
    "请输入水印": "Enter watermarks",
    '取消': 'Cancel',
    '确定': 'OK',
    '提交': 'Submit',
    "暂无搜索结果": "No results found",
    "子团队继承规则": "Sub-team inheritance rules",
    "最多可下载次数": "Maximum times of downloading allowed",
    "还未配置规则": "No rules have been configured yet",
    "您可以添加规则来限制网盘成员使用链接的设置项": "You may add rules to restrict zBox members from using link setting items",
    "没有相应的目录": "No corresponding directory",
    "白名单": "Whitelist",
    "管控目录": "Directory",
    "管控用户": "Control user",
    '创建者': 'Creator',
    '审批者': 'Approver',
    '创建时间': 'Create Time',
    '操作': 'Operation',
    '设置': 'Settings',
    '删除': 'Delete',
    "返回链接管控设置": "Back to link security policy",
    "目录链接规则设置": "Directory link rule settings",
    "点击或搜索目录名": "Click or search for directory name",
    '企业空间': 'Enterprise Space',
    "设置普通链接管控": "Set up link control",
    "设置安全链接管控": "Set up secure link control",
    "次": "times",
    "小时": "hour(s)",
    '所有用户': 'All members',
    '删除成功': 'Delete successfully',
    "删除失败": "Delete Unsuccessful",
    "管控规则已达上限": "Control rules have reached the upper limit",
    '提交成功': 'Submit successfully',
    '提交失败': 'Submission failed',
    '网络问题，请重新尝试提交': 'Network problems, please submit again',
    "请输入": "Please input",
    "水印": "Watermarks",
    "请选择要管控的目录": "Select directories to be controlled",
    "请选择受管控的用户": "Select users to be controlled",
    "请至少允许一项": "Allow at least one",
    "始终链接到文件最新版本": "Always link to the latest version of the file",
    '提示': 'Reminder',
    "链接安全管控规则不会影响历史创建的安全链接，请检查历史链接是否存在安全风险！是否确认提交？": "Link security control rules do not affect the security links created in the past. Please check whether there are security risks in links created in the past! Do you confirm your submission?",
    "您确认要删除选中的管控规则吗？": "Are you sure you want to delete the selected control rule?",
    "全局规则获取失败": "Failed to get the global rule",
    "输入用户名或邮箱，添加白名单用户": "Enter your username or email address to add users on the whitelist",
    "白名单仅可以添加用户，被添加到白名单的用户不受到管控规则的影响。": "Whitelist only supports adding users. Users added on the whitelist will not be affected by the control rules.",
    //sp2-end
    // 安全连接翻译结束
    //hover优化start
    '路径：': 'Path:',
    '邮箱：': "Email:",
    //hover优化end

    //文件夹加密start
    '名称': 'Name',
    '邮箱':'Email',
    '路径': 'Path',
    '管控成员设置成功':'Control members set successfully',
    '管控规则设置成功':'Control rules set successfully',
    '还未添加管控成员':'No control members have been added',
    '添加白名单':'Add whitelist',
    '搜索目录：':'Search directory:',
    '搜索用户：':'Search name:',
    '管控规则：':'Control rules:',
    '添加管控白名单':'Add control whitelist',
    '所属团队':'Team',
    '请输入管控目录内的文件夹名称':'Please enter the folder name in the control directory',
    '添加管控规则白名单：':'Add whitelist of control rules:',
    '受管控成员白名单：':'Whitelist members:',
    '添加受控成员白名单':'Add whitelist of Controlled Members',
    '管控目录白名单：':'Whitelist directory:',
    '审批目录白名单：':'Whitelist directory:',
    '添加白名单目录':'Add whitelist directory',
    '还没有添加白名单目录':'No whitelisted directories',
    '还没有添加白名单':'No whitelist',
    '请选择一个管控目录':'Please select a control directory',
    '请添加受管控成员':'Please add a controlled member',
    '当前配置与历史配置规则冲突，重复配置将覆盖之前记录，是否需要覆盖？':'The current configuration conflicts with the historical configuration rules. Repeated configuration will overwrite previous records. Do you need to overwrite?',
    '您的企业暂未开通此服务，如需开通功能请拨打客服电话：400-898-7968':'Your company has not yet activated this service. If you need to activate the function, please call customer service: 400-898-7968',
    '您的企业暂未开通此服务':'Your company has not yet activated this service.',
    '如需开通功能请拨打客服电话：400-898-7968':'If you need to activate the function, please call customer service: 400-898-7968',
    '设置离线文档管控，会对下载到本地的敏感文档有更安全的保护':'Setting offline document management and control will have more secure protection for sensitive documents downloaded to the local',
    '白名单设置成功':'Whitelist set successfully',
    '路径不存在':'Path does not exist',
    '已选择该目录':'The directory is selected',
    '可添加管控目录下的子目录不受管控规则限制':'Add sub-directories under the control directory are not restricted by control rules',
    '添加失败，团队、组织或成员超出100条上限':'Failed to add, teams, organizations or members exceeds the maximum of 100',
    '添加失败，团队或成员超出100条上限':'Failed to add, the number of teams or members exceeds the maximum of 100',
    '已选择该用户':'This user is selected',
    '选择的用户为白名单中的用户，管控将不会对此用户生效':'The selected user is a user on the white list, and the control will not take effect for this user',
    '选择的用户中存在白名单用户，管控将不会对此类用户生效':'There are whitelisted users in the selected users, and the control will not take effect for such users',
    //文件夹加密end
    '管理员':'Administrator',
    '团队管理员': 'Team administrator',
    '最多能设置5个审批者':'Up to 5 approvers can be set',
    '没有相应的成员':'No corresponding members',
    '：':':',
    '常用': "Common",
    '管理员重置密码后,用户首次登录需要修改密码': "After the administrator resets the password, the user needs to change the password for the first login",
    '设置成功':'Setting is successful',
    '设置失败':'Setting is Faild',
    '成功':'Successful',
    '失败':'Failed',
    '受管控对象':'Controlled object',
    '全部成员':'All users',
    '共{0}项':'{0} objects in total',
    '链接审批规则':'Link approval rules',
    '默认审批者规则':'the default approver rules',
    '添加审批规则':'Add approval rules',
    '全部受管控成员':'All controlled members',
    '添加管控':'Add control',
    '还没有管控对象':'No control objects yet',
    '请选择链接审批者':'Please select link approver',
    '受管控成员':'Controlled members',
    '链接审批设置':'Link approval settings',
    '选择的对象中存在白名单用户，审批规则将不会对此类用户生效':'There are whitelist users in the selected object, and the approval rules will not be effective for such users',
    '继续添加，该对象将受到离线文档管控的限制':'Continue to add, the object will be restricted by offline document control',
    '当前选择的对象中包含未在功能管控范围的对象':'The currently selected object contains objects that are not in the scope of functional control',
    '当前选择的对象未在功能管控对象范围内':'The currently selected object is not within the scope of the function control object',
    '开启后仅能通过windows客户端下载网盘内文件，下载的文件将会加密，有效提升数据安全性':'After opening, you can only download the files in the network disk through the Windows client. The downloaded files will be encrypted to enhance data security',
    '不加入IP访问限制': 'Do not add IP access restrictions',
    '管理员可设定访问网盘的IP地址限制': 'Administrators can set IP address restrictions for accessing Lenovo Box',
    '不勾选该项，需通过访问管理指定的IP地址访问网盘': 'If this item is not checked, you should access Lenovo Box by accessing the IP address designated by the administrator',
    '勾选该项的用户/团队，则该用户/团队访问网盘不受IP地址限制': 'If this item is checked, the user/team can access Lenovo Box without being subject to IP address restrictions',
    '添加审批规则白名单':'Add whitelist of approval rule',
};






// WEBPACK FOOTER //
// ./static/js/language/en.js